import React from 'react'
import { Icon } from '@chakra-ui/react'
import { FiSearch, FiX } from 'react-icons/fi'
import type { InputProps, InputGroupProps } from '@chakra-ui/react'
import { Input, InputGroup, InputLeftElement } from '@chakra-ui/react'
import { InputRightElement } from '@chakra-ui/react'

interface Props extends InputProps {
    containerProps?: InputGroupProps
    hasClear?: boolean
}

export default function SharedSearchBar({
    containerProps,
    hasClear,
    ...rest
}: Props) {
    return (
        <InputGroup size="sm" {...containerProps}>
            <InputLeftElement>
                <Icon as={FiSearch} color="gray.500" />
            </InputLeftElement>
            <Input rounded="md" placeholder="Search..." {...rest} />
            {hasClear && rest.value && (
                <InputRightElement>
                    <Icon
                        cursor="pointer"
                        as={FiX}
                        color="gray.500"
                        onClick={() =>
                            rest.onChange?.({ target: { value: '' } } as any)
                        }
                    />
                </InputRightElement>
            )}
        </InputGroup>
    )
}
